import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSpecificPrivateTransactions } from "../../../redux/features/privatetransactions/privatetransactions";
import { useParams, useNavigate } from "react-router-dom";
import StatusContainer from "../../../components/_utils/CommonStatus/StatusContainer";
import TabsWeapperSection from "../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import InfoCard from "../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import { formatAccountNumber } from "../../../components/_utils/FormatAccountNumber";
import useCategories from "../../../utils/useCategories";
import FormatAmount from "../../../components/_utils/FormatAmount/FormatAmount";
import TEXT from "../../../utils/globalText.js";

import { setHideBreadCrumb } from "../../../redux/features/hideBreadCrumb/hideBreadCrumb.js";
import { GlobalConfiguration } from "../../../utils/configurationProvider.js";

const PrivateOtpValidationSucess = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const categoryMapper = useCategories();
  const navigate = useNavigate();

  const {
    specificPrivateTransactionsData,
    specificPrivateTransactionsLoading,
  } = useSelector((state) => state.privatetransactions);

  const { services } = useSelector((state) => state.refreshToken);

  const buttonRows = [
    [
      {
        btnText: "Authenticate more",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/settings/add_button_white.svg",
        handleFunction: () => {
          navigate(`/private_transaction_dashboard/authentication_file`);
        },
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/create_flow/view_details.svg",
        handleFunction: () => {
          navigate(
            `/private_transaction_dashboard/private_transaction_view_all/private_transaction_detail_page/${
              specificPrivateTransactionsData?.private_transaction
                ?.request_reference_id
            }`,
          );
        },
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: "https://q2pay.in/new_assets/common/dashboard/dashboard.svg",
        handleFunction: () => {
          navigate(`/private_transaction_dashboard`);
        },
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));
    dispatch(getSpecificPrivateTransactions({ id }));
    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, []);

  return (
    <>
      <StatusContainer
        isLoading={specificPrivateTransactionsLoading}
        status="success"
        hoverOption="white"
        title={"Private transaction created successfully."}
        buttonRows={buttonRows}
      >
        <TabsWeapperSection title="File details">
          <>
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    specificPrivateTransactionsData?.transaction_request
                      ?.file_name,
                  leftSubTitle: "File name",
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: (
                    <>
                      INR{" "}
                      <FormatAmount
                        price={
                          specificPrivateTransactionsData?.private_transaction
                            ?.total_amount ?? GlobalConfiguration.lengthCheckOne
                        }
                      />
                    </>
                  ),
                  leftSubTitle: "Transaction amount",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    specificPrivateTransactionsData?.private_transaction
                      ?.total_beneficiary_account_count,
                  leftSubTitle: "Total beneficiaries count",
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    specificPrivateTransactionsData?.transaction_request
                      ?.category,
                  leftSubTitle: "Category",
                  icon: categoryMapper(
                    specificPrivateTransactionsData?.transaction_request
                      ?.transaction_request?.category,
                  ),
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    specificPrivateTransactionsData?.private_transaction?.logs[
                      GlobalConfiguration?.lengthCheckOne
                    ]?.narration,
                  leftSubTitle: "Narration",
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              onClick={() => {
                if (!services?.includes("VAccount")) {
                  navigate("/feature_not_assigned", {
                    state: {
                      unavailableService: "VAccount",
                    },
                  });
                } else {
                  const sourceId =
                    specificPrivateTransactionsData?.transaction_request
                      ?.owner_account_details?.owner_account_id;
                  navigate(
                    `/owner_account_dashboard/owner_accounts_view_all/owner_accounts_detail_page/${sourceId}`,
                  );
                }
              }}
              hoverable="black"
              rows={[
                {
                  leftTitle: formatAccountNumber(
                    specificPrivateTransactionsData?.transaction_request
                      ?.owner_account_details?.owner_account_bank_acc_no,
                  ),
                  leftSubTitle: "Source account",
                  ifsc: specificPrivateTransactionsData?.transaction_request
                    ?.owner_account_details?.owner_account_ifsc_code,
                  rightIcon: true,
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    Array.isArray(
                      specificPrivateTransactionsData?.private_transaction
                        ?.labels,
                    ) &&
                    specificPrivateTransactionsData?.private_transaction?.labels
                      .length > GlobalConfiguration?.lengthCheckZero
                      ? specificPrivateTransactionsData?.private_transaction?.labels.map(
                          (item, index, arr) => (
                            <span key={index}>
                              {item}
                              {index <
                                arr.length -
                                  GlobalConfiguration?.lengthCheckOne && ", "}
                            </span>
                          ),
                        )
                      : TEXT?.NO_LABELS_ASSIGNED,
                  leftSubTitle: "Labels",
                },
              ]}
            />
          </>
        </TabsWeapperSection>
      </StatusContainer>
    </>
  );
};

export default PrivateOtpValidationSucess;
